const DEFAULT_EXCERPT_LENGTH = 80;

export const capitalize = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export function getTextExcerpt(string: string, maxLength: number = DEFAULT_EXCERPT_LENGTH): string {
  if (string.length <= maxLength) {
    return string;
  }
  const strings = string.slice(0, maxLength).split(' ');
  if (strings.length > 1) {
    strings.pop();
  }
  return `${strings.join(' ')}…`;
}
